import React, { useEffect, useState } from 'react'

export const ChuGiaiNongHoa = (props) => {
    const [listChuGiais, setListChuGiai] = useState([]);
    useEffect(()=>{
        setListChuGiai(props.listChuGiais);
    }, [props.listChuGiais]);
    const clickRow = (item) => {
        item.Checked = !item.Checked;
        setListChuGiai([...listChuGiais]);
        props.clickChuGiai(listChuGiais.filter(x => x.Checked).map(x => "'" + x.maNongHoa + "'").join(','));
    }
    return (
        <table className="table table-bordered tb-chu-giai" width="100%">
            <thead>
                <tr>
                    <th rowSpan="2" className="col-checkbox"></th>
                    <th rowSpan="2" className="mau-ky-hieu">Màu sắc Ký hiệu</th>
                    <th colSpan="9">Đặc tính nông hóa</th>
                </tr>
                <tr>
                    <th>pHKCL</th>
                    <th>TPCG</th>
                    <th>OC(%)</th>
                    <th>N(%)</th>
                    <th>P2O5ts(%)</th>
                    <th>K2Ots(%)</th>
                    <th>P2O5dt(mg/100g đất)</th>
                    <th>K2Odt(mg/100g đất)</th>
                    <th>CEC(meq/100g đất)</th>
                </tr>
            </thead>
            <tbody>
                {
                    listChuGiais?.map((item, key) => {
                        return (
                            <tr onClick={() => clickRow(item)} key={key}>
                                <td className="col-checkbox">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" checked={item.Checked} readOnly />
                                    </div>
                                </td>
                                <td className="mau-ky-hieu">
                                    <div style={{backgroundImage: `url("${item.image}")`}}>
                                        <span>{item.maNongHoa}</span>
                                    </div>
                                </td>
                                <td>{item.pHKCL}</td>
                                <td>{item.tPCG}</td>
                                <td>{item.oC}</td>
                                <td>{item.tsDam}</td>
                                <td>{item.tsLan}</td>
                                <td>{item.tsKali}</td>
                                <td>{item.dtLan}</td>
                                <td>{item.dtKali}</td>
                                <td>{item.cEC}</td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
}
